import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-def854ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

import ProjectPanel from '@/components/top/ProjectPanel.vue'
import { useProjectList } from '@/logic/TopLogic'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  projects,
  loading,
} = useProjectList();

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(ProjectPanel, {
      projects: _unref(projects),
      show: !_unref(loading)
    }, null, 8, ["projects", "show"]), [
      [_directive_loading, _unref(loading)]
    ])
  ]))
}
}

})